<template>
    <v-container fill-height class="align-start">
        <v-row no-gutters class="align-self-center mt-16">
            <v-col>
                <loading-overlay :loading="loading"></loading-overlay>
                <v-row class="justify-space-between pa-4 absolute-top align-center" no-gutters>
                    <v-col>
                        <v-row class="align-center" no-gutters>
                            <v-col class="flex-grow-0">
                                <v-img
                                    alt="logo"
                                    src="/svg/logo.svg"
                                    class="align-self-start mb-1"
                                    width="125"
                                    contain
                                ></v-img>
                            </v-col>
                        </v-row>
                    </v-col>
                    <!-- <v-col class="text-right">
                        <p>
                            <span class="body-2 grey--text text--darken-1 d-none d-sm-inline-flex flex-wrap">Don’t have an account?</span>
                            <router-link :to="{ name: 'sign-up' }">
                                <v-btn
                                    href="#"
                                    class="px-sm-12 ml-4"
                                    color="primary"
                                    outlined
                                    medium
                                >
                                    Sign up
                                </v-btn>
                            </router-link>
                        </p>
                    </v-col> -->
                </v-row>
            <v-row class="py-12" align="center" justify="center" no-gutters>
                <v-col class="form">
                        <h1 class="display-1 font-weight-bold primary--text mb-4">Password Reset</h1>
                        <h2 class="subtitle-1 mb-8">Update your password with your email.</h2>
                        <v-form class="text-center" @keyup.native.enter="submitPasswordReset" @submit.prevent="submitPasswordReset">
                            <v-text-field
                                aria-required
                                required
                                autofocus
                                type="text"
                                label="Email"
                                v-model="email"
                                append-icon="mdi-email-outline"
                                background-color="#fcfcfc"
                                color="primary"
                                outlined
                            >
                            </v-text-field>

                            <v-row no-gutters class="align-center">
                                <v-col>
                                    <p class="caption primary--text mb-0 pa-6">
                                        Already know your password? <router-link :to="{ path: 'login' }"> <strong>Sign In</strong></router-link>
                                    </p>
                                </v-col>
                                <v-col class="text-right">
                                    <v-btn
                                        class="px-12"
                                        color="primary"
                                        type="submit"
                                        block
                                        dark
                                        depressed
                                        x-large
                                    >
                                        Reset password
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                </v-col>
            </v-row>
            <v-row align="center" justify="center">
                <v-col class="form">
                        <v-row>
                            <v-col class="d-flex justify-space-between align-center">
                                <a class="caption primary--text font-weight-bold pa-4" href="#">Home</a>
                                <a
                                    href="https://www.kaoshinetwork.com/terms_of_service.html"
                                    class="caption primary--text font-weight-bold pa-4"
                                    target="_blank"
                                >
                                    Legal
                                </a>
                                <a
                                    href="https://www.kaoshinetwork.com/privacy_policy.html"
                                    target="_blank"
                                    class=" caption primary--text font-weight-bold pa-4"
                                >
                                    Privacy Policy
                                </a>
                            </v-col>
                        </v-row>
                        <p class="caption pb-6 mb-8 grey--text">&copy; {{ year }} Kaoshi. All rights reserved. Trademarks and brands are the property of their respective owners.</p>
                </v-col>
            </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name: "password-reset",
        methods: getMethods(),
        mounted: mounted,
        data: data
    }

    function getMethods(){
        return {
            submitPasswordReset: submitPasswordReset
        }

        function submitPasswordReset(){
            const vm = this;
            vm.loading = true;
            const payload = {
                email: vm.email
            };

            Vue.backendApi().auth().passwordReset(payload).then(success, error);

            function success(response) {
                vm.loading = false;
                vm.$swal({
                    type: 'success',
                    title: 'Request sent',
                    text: 'Click OK to continue',
                    preConfirm: () => {
                        vm.$router.push({name: 'password-reset-instructions'});
                    }
                });

            }

            function error(error) {
                vm.loading = false;
                vm.$swal({
                    type: 'error',
                    title: 'Error resetting password',
                    text: error
                });
            }
        }
    }

    function mounted(){
        window.dispatchEvent(new Event('positionBottomButton'));
    }

    function data(){
        return {
            year: Vue.moment().year(),
            loading: false,
            email: ''
        }
    }
</script>

<style scoped>
.slogan {
    color:#1a224e;
    font-size: .625rem!important;
    font-weight: 400;
    letter-spacing: .1666666667em!important;
    line-height: 1rem;
    font-family: Roboto,sans-serif!important;
    margin-top: .625rem;
    margin-left: 1rem;
    margin-bottom: 0;
    white-space: nowrap;
}
.form {
    text-align: center;
    max-width: 350px;
}

@media screen and (min-width: 600px) {
    .absolute-top {
        position: fixed;
        top: 0px;
        left: 50%;
        transform: translateX(-50%);
        max-width: 1300px;
        width: 90%;
    }
}
</style>
